import React, { useState, useEffect } from 'react';
import { FaBars } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import './navbar.css';
import {
  Nav,
  NavbarContainer,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLinks,
  NavLinksRouter,
  Circle,
  NavLogo,
  NavLogoRouter,
} from './Navbar.elements';

const SECTIONS = [
  { to: 'home', label: 'Home' },
  { to: 'about', label: 'About' },
  { to: 'skills', label: 'Skills' },
  { to: 'experience', label: 'Experience' },
  { to: 'projects', label: 'Projects' },
  { to: 'certifications', label: 'Certifications' },
  { to: 'gallery', label: 'Gallery' },
  { to: 'contact', label: 'Contact' },
];

function Navbar({ toggle }) {
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY >= 60);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Nav className={scrolled ? 'active' : ''}>
      <NavbarContainer>
        {isHome ? (
          <NavLogo to="home" smooth duration={500} spy exact="true" offset={-80}>
            EnesG. <Circle />
          </NavLogo>
        ) : (
          <NavLogoRouter to="/">
            EnesG. <Circle />
          </NavLogoRouter>
        )}

        <MobileIcon onClick={toggle}>
          <FaBars />
        </MobileIcon>

        <NavMenu>
          {SECTIONS.map((s) => (
            <NavItem key={s.to}>
              {isHome ? (
                <NavLinks
                  to={s.to}
                  smooth
                  duration={500}
                  spy
                  exact="true"
                  offset={-70}
                >
                  {s.label}
                </NavLinks>
              ) : (
                <NavLinksRouter to="/">{s.label}</NavLinksRouter>
              )}
            </NavItem>
          ))}
        </NavMenu>
      </NavbarContainer>
    </Nav>
  );
}

export default Navbar;
